export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Progression hebdomadaire"])},
        "subtitle_plan_sales": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contrats vendus par semaine."])},
        "subtitle_gross_sales": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volume de ventes brutes par semaine."])},
        "legend_actual": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Réel"])},
        "legend_target": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Objectif"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Weekly progression"])},
        "subtitle_plan_sales": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contracts sold per week."])},
        "subtitle_gross_sales": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gross sales volume per week."])},
        "legend_actual": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actual"])},
        "legend_target": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Target"])}
      }
    }
  })
}
